import './animations.js';
import './header.js';
import './embla-init.mjs';
import './latest-posts.js';
import './newsletter.js';
import './footer.js';
import './hero-image.js';
import './support.js';
import './available-machines.js';
import './product-categories.js';
import './product-advantages.js';
import './universal-content-module.js';
import './map.js';
import './opinions.js';
import './all-faqs.js';
import './header-machine.js';
import './product-hero.js';
import './custom-select.js';
import './information.js';
import './equipment.js';
import './product-modal.js';
import './contact.js';
import './post-content.js';
import './blog.js';
import './lord-icon.js';